import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';

import {styles} from './ReportCardSubheading.style';

interface ReportCardSubheadingProps {
  label: React.ReactNode;
  value: React.ReactNode;
}

const ReportCardSubheading: React.FC<ReportCardSubheadingProps> = ({
  label = null,
  value = null,
}) => {
  return (
    <Gutter style={styles.base}>
      <Text variant="subheading" emphasis="low" style={styles.label}>
        {label}
      </Text>
      <View style={styles.value}>{value}</View>
    </Gutter>
  );
};

export default ReportCardSubheading;
